<template>
  <div class="incoming-call-list">
    <div
      class="incoming-call-list__item"
      v-for="call in calls"
      v-bind:key="call.id"
    >
      <patient-call-card
        v-for="candidate in call.candidates"
        v-bind:key="candidate.id"
        v-bind:actions="candidate.actions"
        v-bind:events="candidate.events"
        v-bind:labels="candidate.labels"
        v-bind:patient-id="candidate.id"
        v-bind:phone="call.phone"
        v-bind:title="candidate.title"
        v-on:copy-patient="onCopyPatient(
          call.id,
          $event,
          candidate.surname_with_initials,
          candidate.age,
          candidate.is_archive,
        )"
        v-on:select-patient="onSelectPatient(call.id, $event)"
        v-on:open-patient-creation-form="onOpenPatientCreationForm(call.phone)"
      />
    </div>
  </div>
</template>

<script>
import PatientCallCard from '@/components/PatientCallCard.vue';

const NAME_EVENT_COPY_PATIENT = 'copy-patient';
const NAME_EVENT_OPEN_PATIENT_CREATION_FORM = 'open-patient-creation-form';
const NAME_EVENT_SELECT_PATIENT = 'select-patient';

/**
 * @description Компонент списка входящих звонков.
 * @type {Vue}
 */
export default {
  components: { PatientCallCard },
  name: 'IncomingCallList',
  methods: {
    /**
     * @description Обработать копирование пациента.
     * @param {number}  callId              Идентификатор звонка.
     * @param {number}  patientId           Идентификатор пациента.
     * @param {string}  surnameWithInitials Фамилия с инициалами пациента.
     * @param {string}  age                 Возраст пациента.
     * @param {boolean} isArchive           Архивность пациента.
     * @returns {void}
     */
    onCopyPatient(callId, patientId, surnameWithInitials, age, isArchive) {
      this.$emit(NAME_EVENT_COPY_PATIENT, callId, patientId, surnameWithInitials, age, isArchive);
    },
    /**
     * @description Обработать выбор пациента.
     * @param {number} callId    Идентификатор звонка.
     * @param {number} patientId Идентификатор пациента.
     * @returns {void}
     */
    onSelectPatient(callId, patientId) {
      this.$emit(NAME_EVENT_SELECT_PATIENT, callId, patientId);
    },
    /**
     * @description Обработать открытие формы создания пациента.
     * @param {string} phoneNumber Номер телефона.
     * @returns {void}
     */
    onOpenPatientCreationForm(phoneNumber) {
      this.$emit(NAME_EVENT_OPEN_PATIENT_CREATION_FORM, phoneNumber);
    },
  },
  props: {
    calls: { required: true, type: Array },
  },
};
</script>

<style scoped lang="scss">
.incoming-call-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
  max-width: 390px;
  padding: 0 10px;
  &__item {
    box-shadow: 0px 4px 13px 0px rgba(66, 66, 66, 0.27);
    display: flex;
    flex-direction: column;
    border-radius: 4px;
  }
}
</style>
